import { Icon, Shadow, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, Pressable } from 'native-base';
import React from 'react';

import { TradingList } from '../TradingListTable';

import { PlatformCardProps } from '.';

export const ContentMobile: React.FC<PlatformCardProps> = ({
  platformName,
  balance,
  allocatedLimit,
  acceptableLoss,
  resultDay,
  tradings,
}) => {
  const [openAccordion, setOpenAccordion] = React.useState('closed');

  const handlePress = () => {
    setOpenAccordion(openAccordion === 'closed' ? 'opened' : 'closed');
  };

  return (
    <Shadow
      borderRadius="md"
      marginBottom={Spacing['inset.sm']}
      paddingX={Spacing['inline.xxxs']}
      level={1}>
      <Pressable
        borderBottomColor={Color['neutral.light']}
        borderBottomWidth={openAccordion === 'opened' ? 1 : 0}
        onPress={handlePress}>
        <HStack alignItems="center" paddingY={Spacing['inset.sm']} maxWidth="100%" flexDir="row">
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.semibold']}
            fontSize={Typography['fontsize.lg']}
            color={['neutral.dark']}
            flex={1}
            textAlign="start">
            {platformName.toLocaleUpperCase()}
          </Text>
          <Icon
            testId="action-icon"
            name="ChevronDown"
            size="sm"
            color={Color['brand.primary.dark']}
          />
        </HStack>
      </Pressable>
      {openAccordion === 'opened' && (
        <VStack width="100%">
          <VStack
            borderBottomColor={Color['neutral.light']}
            borderBottomWidth={1}
            paddingY={Spacing['inset.sm']}>
            <HStack py={Spacing['inset.quarck']} justifyContent="space-between">
              <Text fontSize={Typography['fontsize.md']}>Saldo disponível</Text>
              <Text fontSize={Typography['fontsize.md']}>{balance}</Text>
            </HStack>
            <HStack py={Spacing['inset.quarck']} justifyContent="space-between">
              <Text fontSize={Typography['fontsize.md']}>Limite alocado</Text>
              <Text fontSize={Typography['fontsize.md']}>{allocatedLimit}</Text>
            </HStack>
            <HStack py={Spacing['inset.quarck']} justifyContent="space-between">
              <Text fontSize={Typography['fontsize.md']}>Prejuízo aceitável </Text>
              <Text fontSize={Typography['fontsize.md']}>{acceptableLoss}</Text>
            </HStack>
            <HStack py={Spacing['inset.quarck']} justifyContent="space-between">
              <Text fontSize={Typography['fontsize.md']}>Resultado do dia </Text>
              <Text fontSize={Typography['fontsize.md']}>{resultDay || '--'}</Text>
            </HStack>
          </VStack>

          <Box paddingX={Spacing['inline.xxxs']}>
            <TradingList tradingList={tradings} />
          </Box>
        </VStack>
      )}
    </Shadow>
  );
};
